<template>
  <div class="AppliedFacets" :class="facetsModifier">
    <ul class="AppliedFacets-List" v-if="hasFacets">
      <li v-for="facet in appliedFacets" :key="facet">
        <button role="button" @click="emits('remove-facet', facet)" class="AppliedFacets-List__Chip t5" data-ht-element="filter-chip" :data-ht-meta-name="appliedFacet(facet).label">
          <span v-if="appliedFacet(facet).swatch" class="swatch" :style="`background-color: ${appliedFacet(facet).swatch.color};`"></span>
          <span>
            {{ appliedFacet(facet).label }}
          </span>

          <Icon icon="close" />
        </button>
      </li>
    </ul>
    <button role="button" class="t5 AppliedFacets-Clear" @click="emits('remove-all-facets')" v-if="hasFacets" data-ht-element="filters-clear">
      {{ terms.filters.clear }}
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { deepClone } from '@utils/performance';

import Icon from '../Global/Icon.vue';

const emits = defineEmits(['remove-facet', 'remove-all-facets']);
const props = defineProps({
  appliedFacets: Array,
  facets: Array,
  terms: Object,
});

const hasFacets = computed(() => {
  return props.appliedFacets.length > 0;
});

const facetsModifier = computed(() => {
  return hasFacets.value ? 'AppliedFacets--Active' : '';
});

const appliedFacet = computed(() => {
  return (payload) => {
    const facets = deepClone(props.facets);
    const [key, value] = Object.entries(payload)[0];

    const values = facets.find((facet) => facet.id === key)?.values;

    const matchingFacet = values.find((facet) => {
      const input = JSON.parse(facet.input);
      const currentValue = input.variantMetafield?.value || input.productMetafield?.value;

      return currentValue === value;
    });

    return matchingFacet;
  };
});
</script>
